"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
const WorkflowConditionalIcon = () => {
    return (react_1.default.createElement(Tooltip_1.default, { title: "This field appears conditionally", placement: "top-end" },
        react_1.default.createElement(Visibility_1.default, null)));
};
exports.default = WorkflowConditionalIcon;
//# sourceMappingURL=WorkflowConditionalIcon.js.map